
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.125 2.742h-.805a1.166 1.166 0 00-.25-.562.616.616 0 00-.5-.227c-.557 0-.924.453-1.101 1.36-.172.9-.258 2.97-.258 6.21 0 2.688-.247 4.82-.742 6.399-.49 1.578-1.357 2.367-2.602 2.367-.25 0-.469-.02-.656-.062a2.172 2.172 0 01-.547-.204l.102-1.539H6.5c.068.25.167.456.297.618.135.161.325.242.57.242.547 0 .89-.568 1.031-1.703.141-1.13.211-2.782.211-4.954 0-3.385.256-5.851.766-7.398.516-1.547 1.406-2.32 2.672-2.32.182 0 .383.026.601.078.224.047.415.107.57.18l-.093 1.515zm5.39 0h-.804a1.165 1.165 0 00-.25-.562.616.616 0 00-.5-.227c-.557 0-.924.453-1.102 1.36-.171.9-.257 2.97-.257 6.21 0 2.688-.248 4.82-.743 6.399-.49 1.578-1.356 2.367-2.601 2.367-.25 0-.469-.02-.656-.062a2.172 2.172 0 01-.547-.204l.101-1.539h.735c.067.25.166.456.296.618.136.161.326.242.57.242.548 0 .891-.568 1.032-1.703.14-1.13.211-2.782.211-4.954 0-3.385.255-5.851.766-7.398.515-1.547 1.406-2.32 2.671-2.32.183 0 .383.026.602.078.224.047.414.107.57.18l-.093 1.515zm-10.78 0H6.93a1.166 1.166 0 00-.25-.562.616.616 0 00-.5-.227c-.558 0-.925.453-1.102 1.36-.172.9-.258 2.97-.258 6.21 0 2.688-.247 4.82-.742 6.399-.49 1.578-1.357 2.367-2.601 2.367-.25 0-.47-.02-.657-.062a2.172 2.172 0 01-.547-.204l.102-1.539h.734c.068.25.167.456.297.618.136.161.326.242.57.242.547 0 .891-.568 1.032-1.703.14-1.13.21-2.782.21-4.954 0-3.385.256-5.851.766-7.398C4.5 1.742 5.391.97 6.656.97c.183 0 .383.026.602.078.224.047.414.107.57.18l-.094 1.515z","fill":"currentColor"}})])
          )
        }
      }
    